// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:30-09-2025
//Last ADD : REMOVED EXCEL ACTIONS

import DayBookType from './dayBookReport.types';

/** ***************** GET DAYBOOK REPORT  LIST START *********************** */
export const getDaybookReportListStart = (getData: any) => ({
	type: DayBookType.GET_DAYBOOK_LIST_START,
	payload: getData,
});

export const getDaybookReportListSuccess = (successData: any) => ({
	type: DayBookType.GET_DAYBOOK_LIST_SUCCESS,
	payload: successData,
});

export const getDaybookReportListFailure = (failureData: any) => ({
	type: DayBookType.GET_DAYBOOK_LIST_FAILURE,
	payload: failureData,
});

export const getDaybookReportListResponseResetStart = () => ({
	type: DayBookType.GET_DAYBOOK_LIST_RESPONSE_RESET,
});

export const getDaybookReportListResponseChanged = () => ({
	type: DayBookType.GET_DAYBOOK_LIST_RESPONSE_CHANGED,
});

/** ***************** GET DAYBOOK REPORT  LIST END *********************** */
